export const PALETTE = {
  black: '#000000',
  blueBlack: '#2E384D',
  blue10: '#DAF2FF',
  blue10tint3: '#F0FAFF',
  blue20: '#9ACEFB',
  blue20tint3: '#D7EBFD',
  blue30: '#1C79C4',
  blue50: '#F0F8FF',
  blue200: '#0270CA',
  navy: '#135A93',
  gold: '#EFB533',
  goldLight: '#FFE999',
  goldDark: '#F0B536',
  green: '#159553',
  green10: '#189A51',
  green20: '#DCEFE5',
  green50: '#F5FFF5',
  green200: '#189A51',
  grey25: '#F9FAFC',
  grey50: '#F3F5F9',
  grey75: '#DADEE6',
  grey100: '#ACB0B9',
  grey150: '#898F9B',
  grey175: '#666E7C',
  grey200: '#40444D',
  orange: '#DF8020',
  orange50: '#FFF4E8',
  orange200: '#DB6E00',
  purple25: '#F3F4FF',
  purple50: '#DBDEFF',
  purple100: '#B8BEFF',
  purple150: '#949DFF',
  purple200: '#545ED4',
  red: '#D63649',
  red10: '#FBF2F2',
  red50: '#FFF1F2',
  red200: '#D63649',
  salmon: '#D16161',
  sand50: '#FBFBFA',
  sand100: '#F8F7F5',
  sand150: '#F4F2EF',
  sand200: '#EDEAE5',
  teal50: '#99DDE0',
  teal100: '#66CBD1',
  teal150: '#33BAC1',
  teal200: '#00A9B2',
  transparent: 'rgba(0,0,0,0)',
  white: '#FFFFFF',
  night50: '#285680',
  night75: '#354655',
  night100: '#194670',
  night150: '#082F54',
  night200: '#03182B',
} as const;
